// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1EvWc","balanceDisclaimer":"posDashboard_balanceDisclaimer__1CqIr"};